import UnsavedChangesBoundary from "./components/common/UnsavedChangesBoundary";
import React, { useId } from "react";
import DrawerA11yWrapper from "./ui/DrawerA11yWrapper";
import ControlDetail from "./pages/controls/ControlDetail";

export default function ControlDetailDrawer({ controlId, onClose }) {
  const titleId = useId();

  if (!controlId) return null;

  return (
    <UnsavedChangesBoundary onClose={onClose} itemName="control">
      {(requestClose) => (
    <DrawerA11yWrapper
      open={Boolean(controlId)}
      onClose={requestClose}
      labelledBy={titleId}
      backdropStyle={overlayStyle}
      containerStyle={drawerStyle}
    >
      <div style={contentStyle}>
        <div id={titleId} style={srOnlyStyle}>
          Control details
        </div>
        <ControlDetail controlId={controlId} embedded onClose={onClose} />
      </div>
    </DrawerA11yWrapper>
      )}
    </UnsavedChangesBoundary>
  );
}

const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "stretch",
  zIndex: 3000,
};

const drawerStyle = {
  width: "640px",
  maxWidth: "90vw",
  height: "100%",
  background: "#ffffff",
  display: "flex",
  flexDirection: "column",
  boxShadow: "0 0 20px rgba(0,0,0,0.15)",
};

const contentStyle = {
  padding: "16px 20px 20px",
  overflowY: "auto",
  flex: 1,
  minHeight: 0,
};

const srOnlyStyle = {
  position: "absolute",
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  border: 0,
};
